import { render, staticRenderFns } from "./ServiceAuthorizationTab.vue?vue&type=template&id=762ba42f&scoped=true"
import script from "./ServiceAuthorizationTab.vue?vue&type=script&lang=js"
export * from "./ServiceAuthorizationTab.vue?vue&type=script&lang=js"
import style0 from "./ServiceAuthorizationTab.vue?vue&type=style&index=0&id=762ba42f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762ba42f",
  null
  
)

export default component.exports